export const GET_TOTAL_STATS = 'SA/get_total_stats';
export const GET_GRAPH_STATS = 'SA/get_graph_stats';

export const LEGENDS = [
    { name: 'SOCIAL AMELIORATION', color: '#A3B3F9', value: 0 },
];
